"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTabNavigationButton = void 0;
const UiElements_1 = require("../../ui/UiElements");
function createTabNavigationButton(id, icon, active = false) {
    const tabsFunctions = {
        tabClick: (event) => tabClickhandler(event, id)
    };
    return new UiElements_1.ButtonEl()
        .setClass('nav-el' + (active ? ' active' : ''))
        .setId(id)
        .addAttribute('data-tab-target-id', id)
        .setEvent('click', tabsFunctions.tabClick)
        .addChild(new UiElements_1.IconEl(icon)
    // new ImageEl('/assets/icons/'+icon+'.svg')
    );
}
exports.createTabNavigationButton = createTabNavigationButton;
function tabClickhandler(event, id) {
    const tabs = Array.from(document.querySelectorAll('[data-tab-id]'));
    let buttonEl;
    if (event.target.nodeName === 'I') {
        buttonEl = event.target.parentElement;
    }
    else {
        buttonEl = event.target;
    }
    const previousActiveTabBtn = document.querySelector('.nav-el.active');
    previousActiveTabBtn === null || previousActiveTabBtn === void 0 ? void 0 : previousActiveTabBtn.classList.remove('active');
    buttonEl.classList.add('active');
    const targetTabId = buttonEl.dataset.tabTargetId;
    for (const tab of tabs) {
        tab.classList.remove('active');
        if (tab.dataset.tabId === targetTabId) {
            tab.classList.add('active');
        }
    }
    PubSub.publish("editor-mode" /* EDITOR_MODE */, id);
}
